import { Headers, APICallResult } from "@infoland/api-controller";
import { GenericController, PagedResult } from "@infoland/iprova-api";

class Api5Controller extends GenericController {
    private defaultHeaders: Headers = {
        "X-Api-Version": "5"
    };

    /**
     * execute GET request
     * @param route The route to call
     * @param suppressErrors Whether to supress the throwing of exceptions on error
     */
    public async getAsync<ReturnType>(route: string, suppressErrors?: boolean, headers?: Headers): Promise<ReturnType | null> {
        let response: APICallResult<ReturnType> = await this.$get<ReturnType>(route, suppressErrors, { ...this.defaultHeaders, ...headers });

        if (response) return response.result;
        else return null;
    }

    /**
     * execute POST request
     * @param route The route to call
     * @param data the data to submit
     * @param suppressErrors Whether to supress the throwing of exceptions on error
     */
    public async postAsync<InputType, ReturnType>(
        route: string,
        data: InputType,
        suppressErrors?: boolean,
        headers?: Headers
    ): Promise<ReturnType | null> {
        let response: APICallResult<ReturnType> = await this.$post<InputType, ReturnType>(route, data, suppressErrors, {
            ...this.defaultHeaders,
            ...headers
        });
        if (response) return response.result;
        else return null;
    }

    /**
     * execute PATCH request
     * @param route The route to call
     * @param data the data to submit
     * @param suppressErrors Whether to supress the throwing of exceptions on error
     */
    public async patchAsync<InputType, ReturnType>(route: string, data: InputType, suppressErrors?: boolean): Promise<ReturnType | null> {
        let response: APICallResult<ReturnType> = await this.$patch<InputType, ReturnType>(route, data, suppressErrors, this.defaultHeaders);

        if (response) return response.result;
        else return null;
    }

    /**
     * execute PUT request
     * @param route The route to call
     * @param data the data to submit
     * @param suppressErrors Whether to supress the throwing of exceptions on error
     */
    public async putAsync<InputType, ReturnType>(route: string, data: InputType, suppressErrors?: boolean): Promise<ReturnType | null> {
        let response: APICallResult<ReturnType> = await this.$put<InputType, ReturnType>(route, data, suppressErrors);

        if (response) return response.result;
        else return null;
    }

    /**
     * execute DELETE request
     * @param route The route to call
     * @param suppressErrors Whether to supress the throwing of exceptions on error
     */
    public async deleteAsync<InputType, ReturnType>(route: string, data?: InputType, suppressErrors?: boolean): Promise<ReturnType | null> {
        let response: APICallResult<ReturnType> = await this.$delete<InputType, ReturnType>(route, data, suppressErrors, this.defaultHeaders);

        if (response) return response.result;
        else return null;
    }

    /**
     * execute GET request and return PagesResult
     * @param route The route to call
     * @param suppressErrors Whether to supress the throwing of exceptions on error
     */
    public async getPagedResultAsync<ReturnType>(route: string, suppressErrors?: boolean, headers?: Headers): Promise<PagedResult<ReturnType>> {
        let response: APICallResult<ReturnType[]> = await this.$get<ReturnType[]>(route, suppressErrors, { ...this.defaultHeaders, ...headers });

        return new PagedResult<ReturnType>(response);
    }
}

const ModernApiController = new Api5Controller();

export default ModernApiController;
